'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.isBreakpointLargeSync = exports.isBreakpointLargeQuery = exports.isBreakpointDesktopSync = exports.isBreakpointDesktopQuery = exports.isBreakpointMobileSync = exports.isBreakpointMobileQuery = void 0;
var tslib_1 = require("tslib");
var magic_messages_1 = require("@gig/magic-messages");
var util_1 = require("../util");
function isBreakpointMobileQuery() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var device;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, window.queryBus.query(magic_messages_1.BREAKPOINT_DEVICE_QUERY)];
                case 1:
                    device = _a.sent();
                    return [2 /*return*/, isBreakpointMobile(device)];
            }
        });
    });
}
exports.isBreakpointMobileQuery = isBreakpointMobileQuery;
function isBreakpointMobileSync() {
    var device = window.eventBus.getLatest(magic_messages_1.BREAKPOINT_DEVICE_UPDATED);
    return isBreakpointMobile(device);
}
exports.isBreakpointMobileSync = isBreakpointMobileSync;
function isBreakpointDesktopQuery() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var device;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, window.queryBus.query(magic_messages_1.BREAKPOINT_DEVICE_QUERY)];
                case 1:
                    device = _a.sent();
                    return [2 /*return*/, isBreakpointDesktop(device)];
            }
        });
    });
}
exports.isBreakpointDesktopQuery = isBreakpointDesktopQuery;
function isBreakpointDesktopSync() {
    var device = window.eventBus.getLatest(magic_messages_1.BREAKPOINT_DEVICE_UPDATED);
    return isBreakpointDesktop(device);
}
exports.isBreakpointDesktopSync = isBreakpointDesktopSync;
function isBreakpointMobile(device) {
    return ([util_1.CssDevice.MOBILE, util_1.CssDevice.PHABLET, util_1.CssDevice.TABLET].indexOf(device) !== -1);
}
function isBreakpointDesktop(device) {
    return [util_1.CssDevice.LARGE, util_1.CssDevice.DESKTOP].indexOf(device) !== -1;
}
function isBreakpointLargeQuery() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var device;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, window.queryBus.query(magic_messages_1.BREAKPOINT_DEVICE_QUERY)];
                case 1:
                    device = _a.sent();
                    return [2 /*return*/, device === util_1.CssDevice.LARGE];
            }
        });
    });
}
exports.isBreakpointLargeQuery = isBreakpointLargeQuery;
function isBreakpointLargeSync() {
    var device = window.eventBus.getLatest(magic_messages_1.BREAKPOINT_DEVICE_UPDATED);
    return device === util_1.CssDevice.LARGE;
}
exports.isBreakpointLargeSync = isBreakpointLargeSync;
